import Loading from "../loading/Loading";
import EmptyResults from "./EmptyResults";

type LoadingResultsProps = {
  description: string;
};

const LoadingResults = (props: LoadingResultsProps) => {
  const { description } = props;

  return (
    <EmptyResults>
      <Loading />
      <EmptyResults.Content>
        <EmptyResults.Text>{description}</EmptyResults.Text>
      </EmptyResults.Content>
    </EmptyResults>
  );
};

export default LoadingResults;
